import { useState } from "react";
import { IDataResult, ResponseStatus } from "../../common/models/Result";
import { Authentication } from "../../common/views/Authentication";
import { DataUtils } from "../../common/views/DataUtils";
import { PreferenceModel, PreferenceType, ShortLineModel } from "../../products/models/ProductModel";
import { PreferenceService } from "../services/PreferenceService";

export default function useFavoriteVM() {
    const service = new PreferenceService();

    const [list, setList] = useState<ShortLineModel[]>([]);
    const [selectedLineId, setSelectedLineId] = useState(0);

    const [loading, setLoading] = useState(false);
    const [showDelete, setShowDelete] = useState(false);

    const getList = () => {
        setList([]);

        if (!Authentication.isLoggedIn()) {
            setLoading(false);
            return;
        }

        const userRoles = Authentication.getUserRoles();
        const customerId = userRoles?.customerId;

        if (customerId <= 0) {
            setLoading(false);
            return;
        }

        const onResult = (result: IDataResult) => {
            if (result.data) {
                setList(result.data);
            }

            setLoading(false);
        }

        const request = service.getFavorites(customerId);
        DataUtils.onRequest(request, onResult)
    }

    const set = (
        lineId: number,
        isDelete: boolean,
        reloaded: boolean,
        callback: (succeed: boolean) => void
    ) => {
        const model: PreferenceModel = {
            customerId: 0,
            date: new Date(),
            id: 0,
            lineId: lineId,
            type: PreferenceType.favorite
        }

        const onResult = (result: IDataResult) => {
            setSelectedLineId(0);
            const succeed = result.status === ResponseStatus.success;

            if (succeed && reloaded) {
                getList();
            }

            callback(succeed);
        }

        let request = null;

        if (isDelete) {
            request = service.delete(model);
        } else {
            request = service.create(model);
        }

        DataUtils.onRequest(request, onResult, false);
    }

    return {
        list,
        selectedLineId,
        loading,
        showDelete, setShowDelete,

        getList,
        set
    }
}